function sentimentTrendsOptions(options = {}) {
  return {
    title: null,
    legend: {
      enabled: false
    },
    chart: {
      height: 350
    },
    yAxis: {
      title: {
        text: null
      },
      labels: {
        enabled: false
      },
      min: 1,
      max: 5
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      line: {
        cursor: options.onClick ? 'pointer' : 'auto',
        events: {
          click: options.onClick
        }
      }
    }
  };
}

export default sentimentTrendsOptions;
